import { createAction, props } from "@ngrx/store";

import { YmkSdkShadeFinderConfiguration } from "@hermes/api-model-shade-finder";

import {
    ShadeFinderCameraDimension,
    ShadeFinderSdkError,
} from "../types/shade-finder.types";

export const fetchShadeFinderConfiguration = createAction(
    "[ShadeFinder] Fetch of shade finder config",
);

export const fetchShadeFinderConfigurationSuccess = createAction(
    "[ShadeFinder] Fetch of shade finder config success",
    props<{ shadeFinderConfig: YmkSdkShadeFinderConfiguration | undefined }>(),
);

// UX states
export const userApprove = createAction(
    "[ShadeFinder] User approves consentment",
);

export const userDisapprove = createAction(
    "[ShadeFinder] User disapproves consentment",
);

export const openModal = createAction("[ShadeFinder] Open modal");

export const closeModal = createAction("[ShadeFinder] Close modal");

export const destroyModal = createAction("[ShadeFinder] Destroy modal");

export const launchCamera = createAction("[ShadeFinder] Launch camera");

export const checkTimeOut = createAction("[ShadeFinder] Check timeout");

export const changeScreenOrientation = createAction(
    "[ShadeFinder] Change screen orientation",
);

export const updateCameraDimension = createAction(
    "[ShadeFinder] Update camera dimension",
    props<{
        cameraDimension: ShadeFinderCameraDimension;
    }>(),
);

export const catchSdkError = createAction(
    "[ShadeFinder] Sdk has an error",
    props<{
        sdkError: ShadeFinderSdkError;
    }>(),
);

export const onAir = createAction("[ShadeFinder] Camera is on air");

export const shadeFinderStarted = createAction(
    "[ShadeFinder] Shade detection started",
);

export const shadeFinderComplete = createAction("[ShadeFinder] Shade found");
